import app from '@/main'

async function userBlock (userId) {
  return await app.wsp.sendRequest({
    data: {
      id: userId
    },
    method: 'user.block'
  })
}

export default userBlock